import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import https from './https.js'
import Vant from 'vant';
import 'vant/lib/index.css';
import wechat from 'weixin-js-sdk'
import VueCropper from 'vue-cropper'
// import 'cropperjs/dist/cropper.css';
import qs from "qs";

Vue.use(VueCropper)
Vue.use(Vant);
Vue.config.productionTip = false
Vue.prototype.$aPost = https.fetchPost;
Vue.prototype.$aGet = https.fetchGet;
Vue.prototype.$vant = Vant;
Vue.prototype.$qs = qs;
Vue.prototype.$wx = wechat

router.beforeEach((to, from, next) => { 
  // console.log(to,from)
  const uid = window.localStorage.getItem('uid')  
  // const openid = localStorage.getItem('openid')   
  if (to.meta.title) {
      document.title = to.meta.title
  }
  if (!uid) {
    if (to.path === '/auth') { 

      next()
    } else {  
      console.log(to)
      localStorage.setItem('now_url',to.fullPath)
      next({ path: '/auth', query: to.query})
      
    } 
  } else { 
    if (to.name === 'release') {
        store.commit('isKeepAlive', to.name);
        next();
    }
    if (to.name === 'HomepageSettings') {
        store.commit('isKeepAlive', to.name);
        next();
    }
    if (to.name === 'addAlbum') {
        store.commit('isKeepAlive', to.name);
        next();
    }
    // console.log('keepalive1')
    // if (from.path == "/release") {
    //   console.log('keepalive2')
    //   from.meta.keepAlive = true;
      
    // } else {
    //   console.log('keepalive3')
    //   from.meta.keepAlive = false;
    // }
    // if(to.path == "/release"){
    //   to.meta.keepAlive = false;
    // }
    next();
  }
  
  
}) 
/* eslint-disable no-new */
let vueMain = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
export default vueMain



// WEBPACK FOOTER //
// ./src/main.js